import script from "./InformationShowAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationShowAdmin.vue?vue&type=script&setup=true&lang=js"

import "./InformationShowAdmin.vue?vue&type=style&index=0&id=79ab286b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79ab286b"]])

export default __exports__